import ReportedPostsSummary from "./ReportedPostsSummary";
export default ReportedPostsSummary;
